import styled from 'styled-components'
import { ContainedButton, HeaderTwo } from 'secondstep-components'

export const Button = styled(ContainedButton)``

export const Header = styled(HeaderTwo)`
  text-align: center;
  padding-bottom: 0.8125rem;
  max-width: 430px;
`

export const Image = styled.img`
  padding: 0 0 1.25rem;
`

export const ModalOutroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1.875rem 0 3.125rem;
  box-sizing: border-box;
`
